export enum EventName {
    message_created = 'message_created',
    message_updated = 'message_updated',
    message_deleted = 'message_deleted',
    chat_created = 'chat_created',
    chat_updated = 'chat_updated',
    chat_deleted = 'chat_deleted',
    chats_bulk_updated = 'chats_bulk_updated',
    user_status_updated = 'user_status_updated',
    department_created = 'department_created',
    department_updated = 'department_updated',
    department_deleted = 'department_deleted',
    template_created = 'template_created',
    template_updated = 'template_updated',
    template_deleted = 'template_deleted',
    quick_reply_created = 'quick_reply_created',
    quick_reply_updated = 'quick_reply_updated',
    quick_reply_deleted = 'quick_reply_deleted',
    bulk_send_started = 'bulk_send_started',
    bulk_send_progress = 'bulk_send_progress',
    user_created = 'user_created',
    user_updated = 'user_updated',
    user_deleted = 'user_deleted',
    session_deleted = 'session_deleted',
    export_created = 'export_created',
    export_updated = 'export_updated',
    export_deleted = 'export_deleted',
}

export const PING_MSG = 'ping';
